import { api } from '../../shared/api/client';
import { writeQuery } from '../../shared/lib/queryCache';
import type { AccountGroup } from './lib/groups';

export const GROUPS_KEY = 'publish:account-groups';

export const publishGroupsApi = {
  saveGroups: async (groups: AccountGroup[]) => {
    const res = await api.put<{ groups: AccountGroup[] }>('/montage/account-groups', { groups });
    writeQuery(GROUPS_KEY, res);
    return res;
  },
};

export interface PostedMedia {
  accountId: string;
  mediaId: string;
}

/**
 * После публикации — учёт работы раздающей (26.10.2026).
 *
 * Ролик из «Роликов B2G» — отметка «Взяла» со ссылками всех пабликов, сама
 * пишет «Отработано». Свой ролик раздающей — отдельная запись «Отработано».
 * У остальных (монтажёр, контент-мейкер) ничего не пишем: их учёт — «Видео».
 */
export async function reportPublished(opts: {
  takeItem: string | null;
  posts: PostedMedia[];
  withBrief: boolean | undefined;
  /** Раздающая ли это: только ей своё «Отработано». */
  logsWork: boolean;
  title: string;
}): Promise<'take' | 'work' | null> {
  const { takeItem, posts, withBrief, logsWork, title } = opts;
  if (!posts.length) return null;
  if (takeItem) {
    await api.post(`/montage/takes/items/${encodeURIComponent(takeItem)}/published-media`, {
      posts, ...(logsWork && withBrief !== undefined ? { withBrief } : {}),
    });
    return 'take';
  }
  if (!logsWork) return null;
  await api.post('/montage/work/posts', { posts, title: title.slice(0, 300), withBrief: withBrief ?? true });
  return 'work';
}

/** Название записи «Отработано» для своего ролика: текст на кадре, иначе первая строка подписи. */
export function workTitleFrom(headline: string, caption: string): string {
  const line = (s: string) => s.replace(/\s+/g, ' ').trim();
  const head = line(headline);
  if (head.length >= 3) return head.slice(0, 120);
  const first = line(caption.split('\n').find((l) => l.trim()) ?? '');
  return first.slice(0, 120);
}
